import { Grid, Link, Typography } from '@material-ui/core';
import { Field, FieldProps } from 'formik';
import React, { useCallback, useMemo } from 'react';
import { Link as RouteLink, RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';

import loginSchema, { LoginSchema } from 'core/schemas/login';
import {
  Form,
  FormSubmitHandler,
  InputField,
  SubmitButton,
} from 'Elements/Form';

import useLogin from './useLogin';

const Container = styled.div`
  padding: ${props => props.theme.spacing(6)}px;
`;

export default function Login({ location }: RouteComponentProps) {
  const login = useLogin();

  const email = useMemo(
    () => new URLSearchParams(location.search).get('email'),
    [location.search]
  );

  const onSubmit: FormSubmitHandler<LoginSchema> = useCallback(
    (credentials, form) => {
      return login(credentials).catch(error => {
        form.setErrors({ email: ' ', password: error });
      });
    },
    [login]
  );

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{ email }}
      validationSchema={loginSchema}
    >
      <Grid container component={Container} direction="column" spacing={4}>
        <Grid item>
          <Typography variant="h1">
            Sisäänkirjautuminen rengasseurantaan
          </Typography>
        </Grid>

        <Grid item>
          <InputField
            type="email"
            name="email"
            autoFocus={email === null}
            placeholder="Syötä käyttäjätunnus"
            margin="none"
          />
        </Grid>

        <Grid item>
          <InputField
            type="password"
            name="password"
            autoFocus={email !== null}
            placeholder="Syötä salasana"
            margin="none"
          />
        </Grid>

        <Grid item>
          <SubmitButton variant="contained" color="primary" fullWidth>
            Kirjaudu sisään
          </SubmitButton>
        </Grid>

        <Grid item>
          <Typography align="center">
            <Field name="email">
              {(props: FieldProps) => {
                const email = props.field.value;

                return (
                  <Link
                    component={RouteLink}
                    to={{
                      pathname: '/password/reset',
                      search: email ? `?email=${email}` : undefined
                    }}
                  >
                    Olen unohtanut salasanani!
                  </Link>
                );
              }}
            </Field>
          </Typography>
        </Grid>
      </Grid>
    </Form>
  );
}
